<form [formGroup]="searchForm" class="p-fluid">
    <div class="p-field search-bar-container w-full">
    <span class="p-input-icon-right">
      <input
          #inputEl
          pInputText
          class="search"
          formControlName="search"
          [placeholder]="placeholder"
          (focus)="onFocus()" />
      <i class="ph ph-magnifying-glass"></i>
    </span>
    </div>
</form>

<div class="relative w-full overflow-visible">
    <ul *ngIf="dropdownVisible" class="dropdown-list absolute left-0 w-full">
        <ng-container *ngIf="customHeader && isSearchEmpty && showHeaderOnEmpty">
            <ng-container *ngTemplateOutlet="customHeader"></ng-container>
        </ng-container>

        <li *ngFor="let item of dropdown; trackBy: trackById">
            <div class="flex flex-column">
                <div class="dropdown-item" (click)="select(item)">
                    <img src="/assets/images/signup/AirportSearchDropdownLogo.webp" alt="Icon" class="airport-icon"/>
                    <div class="dropdown-details">
                        <span class="airport-city">
                {{ (getCityForPhoto ? getCityForPhoto(item) : '') || item.cityName || item.name }}{{ item.stateName ? ', ' + item.stateName : '' }}
              </span>
                        <span class="airport-country">
                {{ item.country?.name || item.country || item.name }}{{ item.code ? ' (' + item.code + ')' : '' }}
              </span>
                    </div>
                </div>
                <div *ngIf="showDealFrequency && item.dealFrequency" style="padding-left: 30px" class="pt-1">
                    <p-tag [value]="(item.dealFrequency | titlecase) + ' deal frequency'"
                        [styleClass]="'text-xs ' + item.dealFrequencyClass">
                        <i class="ph-fill ph-chart-bar mr-1"></i>
                    </p-tag>
                </div>
            </div>
        </li>
    </ul>
</div>
